import type { Task } from '@serb/shared';

const base = { rule: false, createdAt: '2026-10-19T06:00:00.000Z', updatedAt: '2026-10-19T06:00:00.000Z' };

/** Made-up tasks for the sample build */
export const CLAUDE_TASKS: Task[] = [
  {
    ...base,
    id: 't1',
    task: 'Check latest rates for Turkey to Aqaba',
    code: '',
    runAt: null,
    status: 'working',
    result: 'Asked 3 agents for rates',
    cardId: null,
  },
  {
    ...base,
    id: 't2',
    task: 'Follow up with the agent for the missing invoice',
    code: 'SRB-625',
    runAt: '2026-10-20T06:00:00.000Z',
    status: 'waiting',
    result: '',
    cardId: null,
  },
  {
    ...base,
    id: 't3',
    task: 'Prepare a quotation',
    code: 'SRB-711',
    runAt: null,
    status: 'needs_you',
    result: 'Quotation ready for your approval',
    cardId: 'a1',
  },
  {
    ...base,
    id: 't4',
    task: 'Update tracking information',
    code: 'SRB-640',
    runAt: null,
    status: 'done',
    result: 'Tracking updated in the shipment note',
    cardId: null,
  },
];
